import { Link } from "react-router-dom";

export function Logo({ dark = false, to = "/" }) {
  return (
    <Link to={to} data-testid="logo-link" className="flex items-center gap-2.5 group">
      <svg viewBox="0 0 1010 770" className="h-6 w-8 shrink-0 transition-transform duration-300 group-hover:scale-110" aria-hidden="true" data-testid="logo-cmyk-bars">
        <polygon points="0,0 150,0 385,770 235,770" fill="#00AEEF" />
        <polygon points="210,0 358,0 593,770 443,770" fill="#EC2A90" />
        <polygon points="418,0 568,0 800,770 650,770" fill="#FFF212" />
        <polygon points="625,0 775,0 1008,770 858,770" fill={dark ? "#FFFFFF" : "#231F20"} />
      </svg>
      <span className={`font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
        Sanvalle<span className="font-medium text-slate-400"> Gráfica</span>
      </span>
    </Link>
  );
}
